import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { TranslateModule } from "@ngx-translate/core";
import { DefaultComponent } from "src/app/default.component";
import { IconReplacePipe } from "src/pipes/icon-replace.pipe";
import { PrefixTemplate } from "../../PrefixTemplate";
import { PrefixValidator } from "../../PrefixValidator";

export type Direction = "horizontal" | "vertical";

export interface CheckboxOption {
  label: string;
}

export type CheckboxState = null | false | true;

@Component({
  imports: [ReactiveFormsModule, TranslateModule, MatCheckboxModule, IconReplacePipe],
  selector: "app-template-checkbox",
  templateUrl: "./template-checkbox.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./template-checkbox.component.less",
})
export class TemplateCheckboxComponent extends DefaultComponent implements PrefixTemplate<boolean>, OnInit {
  @Input({ required: true })
  public control: FormControl<boolean | null>;

  @Input()
  public value: boolean | null;

  @Input()
  public label: string | null;

  @Input()
  public required: boolean;

  @Input()
  public disabled: boolean;

  public constructor() {
    super();
    this.control = new FormControl();
    this.value = null;
    this.label = null;
    this.required = false;
    this.disabled = false;
  }

  public ngOnInit(): void {
    this.addValidators(this.control);
  }

  private addValidators(control: typeof this.control): void {
    if (this.required) control.addValidators([PrefixValidator.required()]);

    control.updateValueAndValidity();
  }
}
